
import "../../../CSS/CanEmpl.css";
import ArchivedModal from "../../Modal/ArchivedModal";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import PreSelectedModal from "../../Modal/preSelectedModal"
import moment from "moment";
import "../../../App.css"
import HaveLicenceImage from "../../../images/HaveLicence.svg";
import NoLicenceImage from "../../../images/noLicence.svg";
import InProgressModal from "../../Modal/InProgressModal";
import RemoveCandidatModal from "../modals/ris/removeFromRis";

const CandidateProfileCard = (props: any) => {
  const navigate = useNavigate();
  const LoginUser = JSON.parse(localStorage.getItem("LoginUser"));
  const [showInProgressModal, setShowInProgressModal] = useState(false);
  const [showArchiveModal, setShowArchiveModal] = useState(false);
  const [showRemoveModal, setShowRemoveModal] = useState(false);

  const CardOptions = [
    {
      value: "Edit Profile",
      label: "Edit Profile",
    },
    { value: "hire", label: "Hire" },
    { value: "archive", label: "Archive" },
  ];

  let state = { profileData: props.data, path: "/candidates" };

  const editCandidatProfile = () => {
    localStorage.setItem("profile", JSON.stringify(props.data));
    navigate(`/candidate/edit/${props.data._id}`, { state: state });
  };

  const viewFullProfile = () => {
    // navigate("/todoprofile", { state: props.data });
    localStorage.setItem("profile", JSON.stringify(props.data));
    window.open(`/candidate/profile/${props.data._id}`, "_blank");
  };


  function padTo2DigitsCH(num) {
    return num.toString().padStart(2, "0");
  }

  function formatDateCha(date) {
    if (date === "") {
      return false;
    }
    return [
      padTo2DigitsCH(date.getDate()),
      padTo2DigitsCH(date.getMonth() + 1),
      date.getFullYear(),
    ].join("/");
  }
  const datenow = moment().format("YYYY-MM-DD");

  let date = new Date(datenow);

  let start = props.data.candidatStartDate !== "" ? new Date(props.data.candidatStartDate) : '';
  let end = props.data.candidatEndDate !== "" ? new Date(props.data.candidatEndDate) : '';

  const MoreOption = (e: any) => {
    if (e.value == "Edit Profile") {
      editCandidatProfile();
    }
    if (e.value == "hire") {
      setShowInProgressModal(true);
    }
    if (e.value == "archive") {
      setShowArchiveModal(true);
    }
  };

  const removeProfile = () => {
    setShowRemoveModal(true);
  }

  return (
    <>
      <div className="tw-bg-white tw-rounded-lg tw-flex tw-flex-col tw-space-y-2 tw-h-[100%] tw-w-[100%]">
        <div onClick={viewFullProfile} className="tw-flex tw-items-center cursor-pointer tw-pt-2">
          {props.data.candidatPhoto &&
            props.data.candidatPhoto?.url !== undefined ? (
            <>
              <div className="col-5 d-flex justify-content-center p-1">
                <img
                  src={props.data.candidatPhoto?.url}
                  className="card-img-top-url"
                  alt="..."
                />
              </div>
              <div className="col-xxl-7 col-xl-7 col-lg-7 col-md-7 col-sm-7 fontStylinForcards">
                <p
                  style={{ width: "100%" }}

                  className="text-dark mb-0"
                  data-bs-toggle="tooltip"
                  data-bs-placement="bottom"
                  title={props.data.candidatName.toLocaleUpperCase()}
                >
                  <b className="TopTodoTitle"
                    style={{
                      color: "#3F76E2",
                    }}
                  >
                    {props.data.candidatName.length > 20
                      ? props?.data?.candidatName
                        .slice(0, 18)
                        .toLocaleUpperCase() + "..."
                      : props?.data.candidatName?.toLocaleUpperCase()}
                  </b>
                </p>
                <p className="text-dark mb-0">
                  {props.data.candidatAge ? (
                    <p className="age00 mb-0">
                      {" "}
                      <b>Age : {props.data.candidatAge}</b>
                    </p>
                  ) : (
                    <b>✘ Age Not Available!</b>
                  )}
                </p>
              </div>
            </>
          ) : (
            <>
              <div className="col-4">
                <img
                  src={require("../../../images/card-men.svg").default}
                  className="card-img-top"
                  alt="..."
                />
              </div>
              <div className="col-xxl-8 col-xl-8 col-lg-8 col-md-8 col-sm-8 fontStylinForcards">
                <p
                  style={{ width: "100%" }}
                  className="text-dark mb-0"
                  data-bs-toggle="tooltip"
                  data-bs-placement="bottom"
                  title={props.data.candidatName.toLocaleUpperCase()}
                >
                  <b className="TopTodoTitle"
                    style={{
                      color: "#000",
                    }}
                  >
                    {props.data.candidatName.length > 20
                      ? props.data.candidatName
                        .slice(0, 21)
                        .toLocaleUpperCase() + "..."
                      : props.data.candidatName.toLocaleUpperCase()}
                  </b>
                </p>
                <div className="text-dark mb-0">
                  {props.data.candidatAge ? (
                    <p className="age00 mb-0">
                      {" "}
                      <b className="TopTodoTitle">
                        Age : {props.data.candidatAge}
                      </b>
                    </p>
                  ) : (
                    <b className="TopTodoTitle">Age : ✘!</b>
                  )}
                </div>
              </div>
            </>
          )}
        </div>

        <StatusAndLicenseSection data={props} />

        <div className="tw-flex tw-flex-col tw-px-4 tw-flex-grow">
          <p className="todoCardbody mb-0">
            <b>
              Sector :{" "}
              {props.data.candidatActivitySector
                ? props.data.candidatActivitySector.toLocaleUpperCase()
                : "✘ No Sector!"}
            </b>
          </p>

          <p className="todoCardbody mb-0">
            <b>
              Job :{" "}
              {props.data.candidatJob
                ? props.data.candidatJob.toLocaleUpperCase()
                : "No Job!"}
            </b>{" "}
          </p>
          <p className="todoCardbody-p mb-0">
            Langues :{" "}
            {/* <b> */}
            {props.data.candidatLanguages.length !== 0
              ? props.data.candidatLanguages.length > 3
                ? props.data.candidatLanguages.slice(0, 3).join(", ") + "..."
                : props.data.candidatLanguages.join(", ")
              : "✘ No Langues Selected!"}
            {/* </b> */}
          </p>
          <p className="todoCardbody-p " style={{ marginBottom: "8px" }}>
            Phone Number :{" "}
            {/* <b> */}
            {props.data.candidatPhone
              ? props.data.candidatPhone
              : "✘ No Phone!"}
            {/* </b>{" "} */}
          </p>

          <p className="preCard-Body-p">
            Email :{" "}
            {/* <b> */}
            {" "}
            {props.data.candidatEmail
              ? props.data.candidatEmail.length > 20
                ? props.data.candidatEmail.slice(0, 22).toLocaleUpperCase() +
                "..."
                : props.data.candidatEmail.toLocaleUpperCase()
              : "✘ No Email Provided!"}
            {/* </b> */}
          </p>
          <p
            className="todoCardbodyBlue py-1"
            style={{
              color: "#3F76E2",
            }}
          >
            Ready for work :{" "}
            {props.data.candidatStartDate
              ? " 📆" + props.data.candidatStartDate : "✘ No Date !"}
          </p>
        </div>

        <div className=" tw-flex tw-justify-between tw-pb-4 tw-px-4">
          {LoginUser?.username === 'PJ Darche' ? <button
            className="btn btn-dark btn-removeprofile-card tw-shadow-lg"
            onClick={() => {
              removeProfile();
            }}
          >
            Remove Profile
          </button> : <Select
            placeholder="Options"
            options={CardOptions}
            className="CardOptions AllMoreOp cursor-pointer"
            onChange={MoreOption}
            isSearchable={false}
            styles={{
              control: (styles, state) => ({
                ...styles,
                borderRadius: '20px',
                fontSize: '12px',
                fontWeight: 'bolder',
                cursor: 'pointer',
              })
            }}
          />}

          <button
            className="btn btn-dark btn-viewprofile-card tw-shadow-lg"
            onClick={() => {
              viewFullProfile();
            }}
          >
            See Full Profile
          </button>
          {showInProgressModal ? (
            <InProgressModal
              props={props.data}
              closeModal={setShowInProgressModal}
            />
          ) : null}
          {showArchiveModal ? (
            <ArchivedModal
              props={props.data}
              closeModal={setShowArchiveModal}
              path={"/candidates"}
              status={"Archived"}
            />
          ) : null}

          {showRemoveModal ? (
            <RemoveCandidatModal
              props={props.data}
              closeModal={setShowRemoveModal}
              path={"/ris-candidates"}
            />
          ) : null}
        </div>
      </div>
    </>
  );
};

export default CandidateProfileCard;

export const StatusAndLicenseSection = ({ data }) => {
  // Define classes and labels based on the status
  const statusBgColor = {
    "New": "#E5EEFF",
    "No Answer": "#FFE1E1",
    "Contacted": "#6FCB94",
    "Interested": "#FEF1E1",
    "Collecting Docs": "#ECF4FF",
    "Pre-Selected": "#ECF4FF",
    "In-Progress": "#DDFFEA",
    "To-Do": "#E5EEFF",
    "Hired": "#DDFFEA",
    "Fired": "#FFE1E1",
    "Denied": "#FFE1E1",
    "Finished": "#ECECEC",
    "Archived": "#FFE1E1",
    "Dead Lead": "#ECECEC",
  };

  const statusTextColor = {
    "New": "#3F76E2",
    "NEW": "#3F76E2",
    "No Answer": "#E21B1B",
    "Contacted": "#FFFFFF",
    "Interested": "#FE8700",
    "Collecting Docs": "#31435B",
    "Pre-Selected": "#31435B",
    "In-Progress": "#489767",
    "To-Do": "#3F76E2",
    "Hired": "#489767",
    "Fired": "#E21B1B",
    "Denied": "#E21B1B",
    "Finished": "#000000",
    "Archived": "#E21B1B",
    "Dead Lead": "#000000",
  }

  const hasLicense = data.data.candidatLicensePermis;
  const status = data.data.candidatStatus;

  const buttonColor = statusBgColor[status];
  const buttonTextColor = statusTextColor[status];

  return (
    <div className="tw-flex tw-mx-4 tw-space-x-4">
      <button className="tw-px-4 tw-py-1 tw-rounded-xl tw-font-bold" style={{ backgroundColor: buttonColor }}>
        <p className="tw-text-xs" style={{ color: buttonTextColor }}>{status}</p>
      </button>
      <div className="d-flex justify-content-center align-items-center">
        <img
          alt="License Status"
          style={{ width: "16px" }}
          src={hasLicense ? HaveLicenceImage : NoLicenceImage}
        />
        <label htmlFor="css" className={hasLicense ? "Licence mb-0" : "NoLicence mb-0"}>
          {hasLicense ? "Have Licence" : "No Licence"}
        </label>
      </div>
    </div>
  );
};